import { render, staticRenderFns } from "./cUpdatezip_new.vue?vue&type=template&id=1d83dc40&scoped=true"
import script from "./cUpdatezip_new.vue?vue&type=script&lang=js"
export * from "./cUpdatezip_new.vue?vue&type=script&lang=js"
import style0 from "./cUpdatezip_new.vue?vue&type=style&index=0&id=1d83dc40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d83dc40",
  null
  
)

export default component.exports